import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { downloadOrderInvoice } from '../../utils/orderInvoice';
import { errorToast } from '../../constants.js/misc';

const OrderInvoiceButton = ({ order, store, formInfo, variant = 'contained', fullWidth = false, className }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);
        try {
            await downloadOrderInvoice({ order, store, formInfo });
        } catch (err) {
            enqueueSnackbar(err?.message || t('OrderDetail.invoiceError'), errorToast);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <Button
            type="button"
            variant={variant}
            color="primary"
            fullWidth={fullWidth}
            className={className}
            disabled={downloading || !order}
            startIcon={<GetAppIcon fontSize="small" />}
            onClick={handleDownload}
        >
            {downloading ? t('OrderDetail.invoiceLoading') : t('OrderDetail.invoiceBtn')}
        </Button>
    );
};

export default OrderInvoiceButton;
